import React from 'react';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import {
  Box, Button, Hidden, styled,
} from '@material-ui/core';
import config from '@/configs/config';
import { Link } from 'react-router-dom';

const StyledButton = styled(Button)({
  backgroundColor: '#e9e9e9 !important',
  width: '100%',
  borderRadius: 0,
  '&:not(:first-child)': {
    marginTop: '14px',
  },
});

const Navigator = ({ paths = [] }) => (
  <Box display="flex" alignItems="center" fontSize={14}>
    <Box fontWeight="bold" mr={3}>
      <Link style={{ color: 'black' }} to="/faq">上一頁</Link>
    </Box>
    { paths.map((path, index) => (
      <React.Fragment key={path}>
        <Box component="span">{path}</Box>
        {index !== paths.length - 1
            && <Box component="span" mx={0.5}>{'>'}</Box>}
      </React.Fragment>
    )) }
  </Box>
);

const Detail = ({
  content,
  icon,
  subIcon,
  subtitle,
  title,
  html = false,
}) => {
  const [isReported, setIsReported] = React.useState(false);
  return (
    <Box px={2}>
      <Hidden only="xs">
        <Navigator paths={['全部主題', title.replace('：', ''), subtitle]} />
      </Hidden>
      <Box display={{ xs: 'flex', sm: 'none' }} alignItems="center">
        <img src={icon} alt="" width="45" height="45" />
        <Box fontWeight="bold" fontSize={14} ml={1}>{title}</Box>
      </Box>
      <Box my={2} borderBottom="1px solid rgb(151,151,151)" />
      <Box px={{ xs: 2, sm: 4 }}>
        <Box my={3} flexGrow={1} display="flex" alignItems="center">
          {subIcon ? <img src={subIcon} alt="" width="45" height="45" /> : <HelpOutlineIcon />}
          <Box fontSize={14} ml={1} color="black">{subtitle}</Box>
        </Box>
        <Box display="flex" flexDirection="column" fontSize={14}>
          {
            html ? (
              <Box whiteSpace="pre-line" dangerouslySetInnerHTML={{ __html: content }} />
            ) : content
          }
        </Box>
      </Box>
      <Box my={4} borderBottom="1px solid rgb(151,151,151)" />
      <Box px={{ xs: 2, sm: 4 }} mb={{ xs: 3, sm: 0 }}>
        <Box>這個回答有幫助到您嗎？</Box>
        {
        isReported
          ? <Box mt={2}>感謝您的回答！</Box>
          : (
            <Box mt={2}>
              <StyledButton onClick={() => setIsReported(true)}>有</StyledButton>
              <StyledButton onClick={() => setIsReported(true)}>沒有</StyledButton>
            </Box>
          )
      }
        <Box textAlign="center" mt={5} fontSize={14} display={{ xs: 'block', sm: 'none' }}>
          <Box>找不到人解答嗎?</Box>
          <Box>
            <Box component="span">請連繫</Box>
            {' '}
            <a
              href={config.faqCustomerServiceUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: 'black',
                textDecoration: 'underline',
              }}
            >
              專人客服
            </a>
            {' '}
            <Box component="span">來為您解答</Box>
          </Box>
        </Box>
      </Box>
      <Hidden only="xs">
        <Box mt={8} mb={3}>
          <Navigator paths={['全部主題', title.replace('：', ''), subtitle]} />
        </Box>
      </Hidden>
    </Box>
  );
};

export default Detail;
